"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokens = void 0;
var _globalTokens = require("../../shared/global-tokens");
var _tokens = _interopRequireDefault(require("../../shared/tokens/tokens"));
var tokens = exports.tokens = {
  color: {
    headings: {
      primary: _globalTokens.globalColor.text.content.main,
      secondary: _globalTokens.globalColor.text.content.auxiliary,
      disabled: _globalTokens.globalColor.text.disabled.onLight,
      white: _globalTokens.globalColor.text.content.onDark
    },
    subheading: {
      default: _globalTokens.globalColor.text.content.main,
      medium: _globalTokens.globalColor.text.content.auxiliary,
      disabled: _globalTokens.globalColor.text.disabled.onLight,
      white: _globalTokens.globalColor.text.content.onDark,
      success: _globalTokens.globalColor.text.semantic.success,
      error: _globalTokens.globalColor.text.semantic.error,
      link: _globalTokens.globalColor.text.link.active
    },
    labels: {
      default: _globalTokens.globalColor.text.content.main,
      disabled: _globalTokens.globalColor.text.disabled.onLight,
      disabledOnDisabled: _globalTokens.globalColor.text.disabled.onDisabled
    },
    body: {
      // deprecated tokens
      default: _globalTokens.globalColor.text.content.main,
      medium: _globalTokens.globalColor.text.content.auxiliary,
      white: _globalTokens.globalColor.text.content.onDark,
      link: _globalTokens.globalColor.text.link.active,
      // New tokens
      main: _tokens.default.sky.sys.color.text.content.main,
      auxiliary: _tokens.default.sky.sys.color.text.content.auxiliary,
      ondark: _tokens.default.sky.sys.color.text.content.ondark,
      primary: _tokens.default.sky.sys.color.text.content.primary,
      accent: _tokens.default.sky.sys.color.text.content.accent,
      error: _tokens.default.sky.sys.color.text.semantic.error,
      disabledOnDisabled: _tokens.default.sky.sys.color.text.disabled.ondisabled,
      disabled: _tokens.default.sky.sys.color.text.disabled.onlight
    },
    detail: {
      default: _globalTokens.globalColor.text.content.main,
      medium: _globalTokens.globalColor.text.content.auxiliary,
      disabled: _globalTokens.globalColor.text.disabled.onLight,
      white: _globalTokens.globalColor.text.content.onDark,
      error: _globalTokens.globalColor.text.semantic.error
    },
    links: {
      active: _tokens.default.sky.comp.textlink.color.text.default,
      hover: _tokens.default.sky.comp.textlink.color.text.hover,
      pressed: _tokens.default.sky.comp.textlink.color.text.pressed,
      disabled: {
        onlight: _tokens.default.sky.sys.color.text.disabled.onlight,
        ondisabled: _tokens.default.sky.sys.color.text.disabled.ondisabled
      },
      background: {
        hover: _tokens.default.sky.comp.textlink.color.background.hover,
        pressed: _tokens.default.sky.comp.textlink.color.background.pressed
      }
    }
  },
  font: {
    link: _tokens.default.sky.sys.font.link[1]
  }
};